import { defineComponent } from "vue";
import { DoughnutChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
export default defineComponent({
    components: {
        DoughnutChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },
    setup: function (props) {
        const options = {
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: props.title,
                    font: {
                        family: "'Exo 2', sans-serif",
                        size: 14
                    },
                    color: "rgb(255, 255, 255)"
                }
            },
        };
        const MIN_LIGHTNESS = 0;
        const MAX_LIGHTNESS = 50;
        const dataLength = props.data.values.length;
        let backgrounds = new Array(dataLength).fill("rgb(0,0,0)");
        backgrounds = backgrounds.map((_, index) => {
            const t = index / dataLength;
            return `hsl(203deg,99%,${(1 - t) * MAX_LIGHTNESS + t * MIN_LIGHTNESS}%)`;
        });
        const chartData = {
            labels: props.data.labels,
            datasets: [{
                    data: props.data.values,
                    borderColor: "rgb(237, 242, 244)",
                    backgroundColor: backgrounds,
                    hoverBackgroundColor: "rgb(217, 4, 41)"
                }]
        };
        return {
            options,
            chartData
        };
    }
});
